<template>
	<div :class="block_results_momentarily ? 'event-card' : ''">
		<div v-if="block_results_momentarily">
			<p class="text-center q-headline q-pt-md">
				{{ $t('no_event_completed_please_come_back_later') }}
			</p>
		</div>

		<div v-else>
			<div class="row justify-center q-mb-sm">
				<q-btn
					color="primary"
					class="q-pa-sm q-mx-xs"
					icon="far fa-check-double"
					:label="$t('print_event_results')"
					@click="printEventResults"
					:disable="!permissions.presential_print_results"
				/>
				<q-btn
					color="primary"
					class="q-pa-sm q-mx-xs"
					icon="far fa-print"
					:label="$t('print_attendance_list')"
					@click="printAttendanceList"
					:disable="!permissions.presential_print_users"
				/>
				<q-btn
					color="secondary"
					class="q-pa-sm q-mx-xs"
					icon="far fa-plus"
					:label="$t('import_result')"
					@click="showImportResult"
					:disable="disableImportParticipant"
				/>
				<q-btn
					color="secondary"
					class="q-pa-sm q-mx-xs"
					icon="far fa-plus"
					:label="$t('add_participants')"
					@click="showAddParticipants"
					:disable="disableFinished || disableAddParticipant"
				/>
			</div>
			<div class="row justify-center q-my-sm" v-show="participants_selected.length > 0">
				<q-btn
					color="negative"
					class="q-pa-sm"
					icon="far fa-ban"
					:label="$t('remove')"
					@click="removeParticipants"
					:disable="disableFinished"
				/>
			</div>

			<q-tabs v-model="tab_results">
				<div
					v-if="
						event_dates[tab_results] !== undefined &&
							event_dates[tab_results].has_test === 3 &&
							!event_dates[tab_results].tests
					"
				>
					<h6 class="q-pa-md text-h6">{{ $t('still_no_results_for_event') }}</h6>
				</div>

				<q-tab
					v-for="(event, index) in event_dates"
					v-if="showEventTab(event)"
					:key="`t${index}`"
					slot="title"
					:name="`${index}`"
					:label="fDate(event.hr_start)"
					:class="$v.event_dates.$each[index].$error ? 'text-negative' : ''"
				/>

				<q-tab-pane
					v-for="(event, index) in event_dates"
					:key="`tp${index}`"
					:name="`${index}`"
				>
					<q-table
						v-if="
							(event_dates[tab_results] !== undefined &&
								event_dates[tab_results].has_test === 3 &&
								event_dates[tab_results].tests &&
								!event_dates[tab_results].tests.length) ||
								event_dates[index].has_test !== 3
						"
						:title="getTestLabel(event_dates[index].has_test)"
						:data="event.participants"
						:columns="
							event_dates[index].has_test === 2
								? columns_participants
								: columns_participants_small
						"
						:pagination.sync="server_pagination"
						selection="multiple"
						:selected.sync="participants_selected"
						row-key="user_id"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[0]"
						class="q-mt-xs"
						binary-state-sort
					>
						<template slot="top" slot-scope="props">
							<q-input
								:float-label="$t('guests_quantity')"
								dense
								v-model="qtyGuestsInvited"
								disable
								readonly
							/>
							<div
								class="q-pt-md col-auto q-ml-auto text-right"
								v-if="showEventNotFinishedWarning(event)"
							>
								<p class="uppercase">
									{{ `${$t('event_not_finished_please_finish')}` }}
									<q-btn
										flat
										class="q-mb-xs"
										color="secondary"
										:label="$t('view_event')"
										@click="goToEvent(event)"
									/>
								</p>
							</div>
							<q-btn
								class="q-ml-auto"
								flat
								color="secondary"
								:label="
									event.is_seleted
										? 'Adicionar presença para todos'
										: 'Remover presença para todos'
								"
								@click="addSelectAll(event.participants)"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox
									v-if="!has_uninvited_guest"
									v-model="props.selected"
									indeterminate-value="some"
									:disable="disableFinished"
								/>
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props">
							<q-td auto-width>
								<q-checkbox
									v-if="!props.row.is_invited"
									color="primary"
									v-model="props.selected"
									:disable="disableFinished"
								/>
							</q-td>

							<q-td key="user_id" :props="props">
								{{ props.row.user_id }}
							</q-td>

							<q-td
								key="full_name"
								:props="props"
								:class="props.row.enrollment_canceled ? 'text-negative' : ''"
							>
								<q-icon
									name="fal fa-exclamation-triangle"
									class="q-pr-sm"
									v-if="props.row.enrollment_canceled"
								>
									<q-tooltip>
										{{ $t('enrollment_canceled') }}
									</q-tooltip>
								</q-icon>
								{{ props.row.full_name }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="document" :props="props">
								{{ props.row.document }}
							</q-td>

							<q-td key="branches" :props="props">
								<q-btn
									color="primary"
									text-color="white"
									:label="getQuantityBranches(props.row.branches)"
									no-ripple
								>
									<q-tooltip v-if="props.row.branches.length > 0">
										<p class="tooltip q-mb-sm">
											{{ $t('branches') }}:
											<span
												v-for="(branch, index) in props.row.branches"
												:key="index"
											>
												{{ branch }}
												<span v-if="props.row.branches.length - 1 > index"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
							</q-td>

							<q-td key="is_present" :props="props">
								<q-checkbox v-model="props.row.is_present" />
							</q-td>

							<q-td
								key="score"
								:props="props"
								v-show="props.row.has_test === 2 ? true : false"
							>
								<q-input
									v-model="props.row.score"
									:error="
										$v.event_dates.$each[index].participants.$each[
											props.row.__index
										].$error
									"
									@input="
										$v.event_dates.$each[index].participants.$each[
											props.row.__index
										].$touch
									"
									:disable="
										event_dates[index].has_test === 1 ||
											!props.row.is_present ||
											disableFinished
									"
								/>
							</q-td>

							<q-td
								key="percent"
								:props="props"
								v-show="props.row.has_test === 2 ? true : false"
							>
								{{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
							</q-td>

							<q-td
								key="status"
								:props="props"
								v-show="props.row.has_test === 2 ? true : false"
							>
								{{ $t(getResult(props.row)) }}
							</q-td>

							<q-td auto-width key="actions" :props="props">
								<q-btn
									v-if="!props.row.is_invited"
									round
									flat
									icon="fal fa-trash"
									color="negative"
									@click="removeParticipant(props)"
									:disable="disableFinished"
								/>
							</q-td>
						</q-tr>
					</q-table>

					<q-tabs v-else v-model="tab_tests">
						<q-tab
							v-for="(test, index) in event_dates[tab_results].tests"
							:key="`t${index}`"
							slot="title"
							:name="`${index}`"
							:label="`${$t('test')} ${index + 1}`"
						/>

						<q-tab-pane
							v-for="(test, index) in event_dates[tab_results].tests"
							:key="`tp${index}`"
							:name="`${index}`"
						>
							<q-table
								:data="event.participants"
								:columns="columns_participants_tests"
								:pagination.sync="server_pagination"
								selection="multiple"
								:selected.sync="participants_selected"
								row-key="user_id"
								:no-data-label="$t('no_data_avaliable')"
								:no-results-label="$t('no_results_found')"
								:loading-label="$t('loading_data')"
								:rows-per-page-label="$t('items_per_page')"
								:rows-per-page-options="[0]"
								class="q-mt-xs"
								binary-state-sort
							>
								<template slot="top" slot-scope="props">
									<q-input
										:float-label="$t('guests_quantity')"
										dense
										v-model="qtyGuestsInvited"
										disable
										readonly
									/>
									<div
										class="q-pt-md col-auto q-ml-auto text-right"
										v-if="showEventNotFinishedWarning(event)"
									>
										<p class="uppercase">
											{{ `${$t('event_not_finished_please_finish')}` }}
											<q-btn
												flat
												class="q-mb-xs"
												color="secondary"
												:label="$t('view_event')"
												@click="goToEvent(event)"
											/>
										</p>
									</div>
									<q-btn
										class="q-ml-auto"
										flat
										color="secondary"
										:label="
											event.is_seleted
												? 'Adicionar presença para todos'
												: 'Remover presença para todos'
										"
										@click="addSelectAll(event.participants)"
									/>
								</template>

								<q-tr slot="header" slot-scope="props" :props="props">
									<q-th auto-width>
										<q-checkbox
											v-if="has_uninvited_guest"
											v-model="props.selected"
											indeterminate-value="some"
											:disable="disableFinished"
										/>
									</q-th>

									<q-th v-for="col in props.cols" :key="col.name" :props="props">
										{{ $t(col.label) }}
									</q-th>
								</q-tr>

								<q-tr slot="body" slot-scope="props">
									<q-td auto-width>
										<q-checkbox
											v-if="!props.row.is_invited"
											color="primary"
											v-model="props.selected"
											:disable="disableFinished"
										/>
									</q-td>

									<q-td key="user_id" :props="props">
										{{ props.row.user_id }}
									</q-td>

									<q-td
										key="full_name"
										:props="props"
										:class="
											props.row.enrollment_canceled ? 'text-negative' : ''
										"
									>
										<q-icon
											name="fal fa-exclamation-triangle"
											class="q-pr-sm"
											v-if="props.row.enrollment_canceled"
										>
											<q-tooltip>
												{{ $t('enrollment_canceled') }}
											</q-tooltip>
										</q-icon>
										{{ props.row.full_name }}
									</q-td>

									<q-td key="email" :props="props">
										{{ props.row.email }}
									</q-td>

									<q-td key="document" :props="props">
										{{ props.row.document }}
									</q-td>

									<q-td key="branches" :props="props">
										<q-btn
											color="primary"
											text-color="white"
											:label="getQuantityBranches(props.row.branches)"
											no-ripple
										>
											<q-tooltip v-if="props.row.branches.length > 0">
												<p class="tooltip q-mb-sm">
													{{ $t('branches') }}:
													<span
														v-for="(branch, index) in props.row
															.branches"
														:key="index"
													>
														{{ branch }}
														<span
															v-if="
																props.row.branches.length - 1 >
																	index
															"
															>,
														</span>
													</span>
												</p>
											</q-tooltip>
										</q-btn>
									</q-td>

									<q-td key="is_present" :props="props">
										<q-checkbox v-model="props.row.is_present" />
									</q-td>

									<q-td key="score" :props="props">
										{{ props.row.tests[tab_tests].user_result.user_score }}
									</q-td>

									<q-td
										key="percent"
										:props="props"
										v-model="
											props.row.tests[tab_tests].user_result.user_percent
										"
									>
										{{
											props.row.tests[tab_tests].user_result.user_percent ||
											props.row.tests[tab_tests].user_result.user_percent == 0
												? `${props.row.tests[
														tab_tests
												  ].user_result.user_percent.toFixed(2)}%`
												: ''
										}}
									</q-td>

									<q-td key="status" :props="props">
										{{
											getResultOnlineTest(
												props.row.tests[tab_tests].user_result
													.user_result_status
											)
										}}
									</q-td>

									<q-td auto-width key="actions" :props="props">
										<q-btn
											v-if="!props.row.is_invited"
											round
											flat
											icon="fal fa-trash"
											color="negative"
											@click="removeParticipant(props)"
											:disable="disableFinished"
										/>
									</q-td>
								</q-tr>
							</q-table>
						</q-tab-pane>
					</q-tabs>
				</q-tab-pane>
			</q-tabs>

			<div class="q-mx-sm row items-start q-gutter-sm">
				<q-card class="col-12">
					<q-card-title>
						{{ $t('participating_audience') }}
					</q-card-title>
					<q-card-separator />
					<q-card-main>
						<div class="row gutter-sm q-pb-sm">
							<div
								class="col-xs-12 col-sm-4"
								v-for="(item, index) in participants_profile"
								:key="`ra${index}`"
							>
								<q-input
									class="custom-input"
									outlined
									v-model="item.qty_participants"
									:prefix="
										`${
											item.label.length < 30
												? item.label
												: item.label.slice(0, 28) + '...'
										} `
									"
								/>
							</div>
						</div>
					</q-card-main>
				</q-card>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('save')" v-if="showFinish">
				<q-btn
					color="positive"
					class="full-width"
					:label="$t('finish')"
					icon="far fa-check"
					@click="finishAppointment()"
					:disable="!permissions.presential_save_results"
				/>
			</div>

			<div
				class="col-xs-12 col-sm-3"
				:class="getOrder('save')"
				v-if="showSave && !block_results_momentarily"
			>
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save_results')"
					icon="far fa-save"
					@click="saveResults()"
					:disable="disableSaveResults"
				>
					<q-tooltip
						v-if="
							permissions.presential_save_results &&
								status === 8 &&
								disableSaveResults
						"
					>
						<span>
							{{ $t('training_finalized_tooltip') }}
						</span>
					</q-tooltip>
				</q-btn>
			</div>
		</div>

		<q-modal
			v-model="show_participants"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_participants = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('participants') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="participants_list"
						:columns="participants_columns"
						:pagination.sync="participants_pagination"
						:filter="filter_participants"
						@request="requestParticipants"
						:loading="loading"
						selection="multiple"
						:selected.sync="participants_selected"
						row-key="id"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
					>
						<template slot="top" slot-scope="props">
							<q-search
								v-model="filter_participants"
								icon="far fa-search"
								:placeholder="$t('search')"
								:float-label="$t('search')"
								:debounce="600"
							/>
							<div class="col" />
							<q-btn
								color="positive"
								icon="far fa-save"
								:label="$t('add_participants')"
								@click="addParticipants()"
								class="q-mr-md"
								v-if="participants_selected.length > 0"
							/>
							<q-btn
								color="positive"
								icon="far fa-user"
								:label="$t('new_users')"
								@click="createdNewParticipants()"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox v-model="props.selected" indeterminate-value="some" />
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td auto-width>
								<q-checkbox color="primary" v-model="props.selected" />
							</q-td>

							<q-td key="id" :props="props">
								{{ props.row.id }}
							</q-td>

							<q-td key="full_name" :props="props">
								{{ props.row.full_name }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="document" :props="props">
								{{ props.row.document }}
							</q-td>

							<q-td key="branches" :props="props">
								<q-btn
									color="primary"
									text-color="white"
									:label="getQuantityBranches(props.row.branches)"
									no-ripple
								>
									<q-tooltip v-if="props.row.branches.length > 0">
										<p class="tooltip q-mb-sm">
											{{ $t('branches') }}:
											<span
												v-for="(branch, index) in props.row.branches"
												:key="index"
											>
												{{ branch }}
												<span v-if="props.row.branches.length - 1 > index"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
							</q-td>

							<q-td key="profile" :props="props">
								{{ translateProfiles(props.row.profile) }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_create_users"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="hideCreateUsers()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('new_users') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm">
						<div class="col-xs-12 col-sm-3">
							<q-field
								:error="new_user.email_error"
								:error-label="
									new_user.email_error ? `${$t('email_not_unique')}` : ''
								"
							>
								<q-input
									:float-label="$t('email')"
									v-model="new_user.email"
									:error="$v.new_user.email.$error"
									@input="$v.new_user.email.$touch"
									@blur="emailUnique()"
								/>
							</q-field>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-field
								:error="new_user.document_error"
								:error-label="
									new_user.document_error ? $t('document_not_unique') : ''
								"
							>
								<q-input
									:float-label="$t('document')"
									v-model="new_user.document"
									:error="$v.new_user.document.$error"
									@input="$v.new_user.document.$touch"
									@blur="documentUnique()"
								/>
							</q-field>
						</div>

						<div class="col-xs-12 col-sm-2">
							<q-select
								:float-label="$t('profile')"
								v-model="new_user.profile"
								:options="register_profiles"
								:error="$v.new_user.profile.$error"
								@input="$v.new_user.profile.$touch"
							/>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-input
								:float-label="$t('full_name')"
								v-model="new_user.full_name"
								:error="$v.new_user.full_name.$error"
								@input="$v.new_user.full_name.$touch"
							/>
						</div>

						<div class="col-xs-12 col-sm-1">
							<q-btn
								class="q-mt-md"
								round
								flat
								color="positive"
								icon="fal fa-plus"
								@click="addNewUser()"
							/>
						</div>
					</div>

					<div class="row gutter-sm" v-for="(user, index) in new_users" :key="index">
						<div class="col-xs-12 col-sm-3">
							<q-input :float-label="$t('email')" v-model="user.email" disable />
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-input
								:float-label="$t(documentChevrolet)"
								v-model="user.document"
								disable
							/>
						</div>

						<div class="col-xs-12 col-sm-2">
							<q-select
								:float-label="$t('profile')"
								:options="register_profiles"
								v-model="user.profile"
								disable
							/>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-input
								:float-label="$t('full_name')"
								v-model="user.full_name"
								disable
							/>
						</div>

						<div class="col-xs-12 col-sm-1">
							<q-btn
								class="q-mt-md"
								color="negative"
								round
								flat
								icon="fal fa-trash"
								@click="removeNewUser(index)"
							/>
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
							<q-btn
								color="tertiary"
								class="full-width"
								:label="$t('cancel')"
								icon="far fa-chevron-left"
								@click="hideCreateUsers()"
							/>
						</div>

						<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
							<q-btn
								color="secondary"
								class="full-width"
								:label="$t('save_new_users')"
								icon="far fa-save"
								@click="saveNewUsers()"
								:disable="new_users.length === 0 ? true : false"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_modal_create_users"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, height: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_modal_create_users = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('new_users') }}
					</q-toolbar-title>
				</q-toolbar>
				<div class="layout-padding">
					<CreateUsers @closeRegisterUser="closeRegisterUser" :id="presential_event_id" />
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_result_import"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_result_import = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('import_result') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<p class="q-mb-none text-weight-light q-mb-md">
						{{ $t('guests_import_template_start') }}
						<span class="text-weight-medium cursor-pointer" @click="getTemplate()"
							>presential_event_users.xlsx</span
						>
						{{ $t('guests_import_template_end') }}
					</p>
					<uploader
						content_type="xlsx"
						@fileUploaded="resultImportUpload"
						:multiple="false"
						:cropper="false"
					/>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								color="negative"
								class="full-width"
								:label="$t('cancel')"
								icon="far fa-times"
								@click="show_result_import = false"
							/>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-btn
								color="secondary"
								class="full-width"
								:label="$t('save')"
								icon="far fa-save"
								@click="importResult()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="show_finish" prevent-close>
			<span slot="title">{{ $t('finish_appointment') }}</span>

			<span slot="message">{{
				$t('do_you_confirm_finishing_this_appointment_this_action_cannot_be_undone')
			}}</span>

			<div slot="body">
				<q-input
					type="textarea"
					:placeholder="$t('observation')"
					v-model="finish_observation"
				/>
			</div>

			<template slot="buttons" slot-scope="props">
				<q-btn color="tertiary" :label="$t('close')" @click="hideFinish()" />
				<q-btn color="positive" :label="$t('finish')" @click="saveFinish()" />
			</template>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date, debounce } from 'quasar'
const { formatDate } = date
import { required, requiredIf, minLength, between, email } from 'vuelidate/lib/validators'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import Uploader from 'components/Uploader'
import CreateUsers from 'components/admin/presential/CreateUser'

export default {
	name: 'AdminPresentialResults',

	props: ['status', 'permissions', 'max_participants', 'events_title'],

	components: {
		uploader: Uploader,
		CreateUsers: CreateUsers,
	},

	data() {
		return {
			presential_event_id: '',
			tab_results: '0',
			tab_tests: '0',
			event_dates: [],
			show_result_import: false,
			columns_participants: [
				{
					name: 'user_id',
					required: true,
					label: '#',
					align: 'left',
					field: 'user_id',
					sortable: false,
				},
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'document',
					required: true,
					label: 'document',
					align: 'left',
					field: 'document',
					sortable: false,
				},
				{
					name: 'branches',
					required: false,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'is_present',
					required: true,
					label: 'present',
					align: 'left',
					field: 'is_present',
					sortable: false,
				},
				{
					name: 'score',
					required: true,
					label: 'number_hits',
					align: 'left',
					field: 'score',
					sortable: false,
				},
				{
					name: 'percent',
					required: true,
					label: 'percentage',
					align: 'left',
					field: 'percent',
					sortable: false,
				},
				{
					name: 'status',
					required: true,
					label: 'test_result',
					align: 'left',
					field: 'status',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'left',
					field: 'actions',
					sortable: false,
				},
			],
			columns_participants_small: [
				{
					name: 'user_id',
					required: true,
					label: '#',
					align: 'left',
					field: 'user_id',
					sortable: false,
				},
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'document',
					required: true,
					label: 'document',
					align: 'left',
					field: 'document',
					sortable: false,
				},
				{
					name: 'branches',
					required: false,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'is_present',
					required: true,
					label: 'present',
					align: 'left',
					field: 'is_present',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'left',
					field: 'actions',
					sortable: false,
				},
			],
			columns_participants_tests: [
				{
					name: 'user_id',
					required: true,
					label: '#',
					align: 'left',
					field: 'user_id',
					sortable: false,
				},
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'document',
					required: true,
					label: 'document',
					align: 'left',
					field: 'document',
					sortable: false,
				},
				{
					name: 'branches',
					required: false,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'is_present',
					required: true,
					label: 'present',
					align: 'left',
					field: 'is_present',
					sortable: false,
				},
				{
					name: 'score',
					required: true,
					label: 'number_hits',
					align: 'left',
					field: 'score',
					sortable: false,
				},
				{
					name: 'percent',
					required: true,
					label: 'percentage',
					align: 'left',
					field: 'percent',
					sortable: false,
				},
				{
					name: 'status',
					required: true,
					label: 'test_result',
					align: 'left',
					field: 'status',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'left',
					field: 'actions',
					sortable: false,
				},
			],
			participants_selected: [],
			server_pagination: {
				page: 1,
				rowsPerPage: 0,
				descending: false,
				sortBy: null,
			},
			filter_participants: '',
			show_participants: false,
			show_modal_create_users: false,
			loading: false,
			participants_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			participants_list: [],
			participants_columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: false,
				},
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'document',
					required: true,
					label: 'document',
					align: 'left',
					field: 'document',
					sortable: false,
				},
				{
					name: 'branches',
					required: false,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'profile',
					sortable: false,
				},
			],
			show_create_users: false,
			new_users: [],
			new_user: {
				email: '',
				email_error: false,
				document: '',
				document_error: false,
				profile: '',
				full_name: '',
			},
			show_finish: false,
			finish_observation: '',
			client_profile: '',
			participants_profile: [],
			has_uninvited_guest: false,
			block_results_momentarily: false,
			qty_participants_base: 0,
			selection: [],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			client_profiles: 'registration_lists/profiles',
			register_profiles: 'registration_lists/profiles',
			register_fields: 'params/register_fields',
			id_user_language_selected: 'common/id_user_language_selected',
			register_store: 'params/register',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			profiles: 'registration_lists/profiles',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '90vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		disableFinished() {
			if (
				(this.status === 8 && !this.permissions.trainings_manage) ||
				!this.permissions.presential_save_results
			)
				return true
			else return false
		},

		disableSaveResults() {
			if (!this.permissions.presential_save_results) return true
			if (
				process.env.PROJECT_FOLDER === 'academiacoral' &&
				this.permissions.presential_save_results
			) {
				return false
			} else {
				if (!this.permissions.presential_save_results || this.status > 5) return true
				else return false
			}
		},

		showFinish() {
			if (this.status === 5 && this.permissions.finish_events) return true
			else return false
		},

		showSave() {
			if (this.status === 5 || this.permissions.trainings_manage) return true
			else return false
		},

		qtyGuestsInvited() {
			return this.event_dates[this.tab_results].participants.length > 0
				? `${
						this.event_dates[this.tab_results].participants.filter(
							(e) => !e.enrollment_canceled
						).length
				  }/${this.max_participants}`
				: `0/${this.max_participants}`
		},

		disableImportParticipant() {
			if (this.qty_participants_base >= this.max_participants) {
				return true
			} else {
				if (!this.permissions.presential_import_results || this.status === 8) return true
				else return false
			}
		},

		disableAddParticipant() {
			if (this.qty_participants_base >= this.max_participants) {
				return true
			} else {
				if (this.status === 6 || this.status === 7 || this.status === 8) return true
				else return false
			}
		},

		is_add_presential() {
			return this.selection.length == this.event_dates[this.tab_results].participants.length
				? false
				: true
		},
	},

	methods: {
		async requestEventDatesAndAudience() {
			this.$q.loading.show()

			try {
				const results = await this.$axios.get(
					`/presential/presential_events/${this.presential_event_id}/results/`,
					this.getHeader
				)
				const audience = await this.$axios.get(
					`/presential/presential_events/${
						this.presential_event_id
					}/results/get_participant_real/`,
					this.getHeader
				)

				let d = results.data
				this.event_dates = d.map((e) => {
					return {
						allow_to_finish: e.allow_to_finish,
						partner_name: e.partner_name,
						company_branch_name: e.company_branch_name,
						presential_event_date_id: e.presential_event_date_id,
						presential_event_date_type: e.presential_event_date_type,
						is_seleted: true,
						event_date: moment(e.event_date)
							.tz('Etc/GMT')
							.format('YYYY-MM-DDTHH:mm:ss.SSS'),
						hr_end: moment(e.hr_end)
							.tz(e.timezone)
							.format('YYYY-MM-DDTHH:mm:ss.SSS'),
						hr_start: moment(e.hr_start)
							.tz(e.timezone)
							.format('YYYY-MM-DDTHH:mm:ss.SSS'),
						has_test: e.has_test,
						minimum_score_approval: e.minimum_score_approval,
						qty_questions: e.qty_questions,
						status: e.status,
						participants: e.participants.map((p) => {
							if (p.is_present) this.selection.push(p.user_id)
							return {
								...p,
								branches: p.branches,
								actions: p.user_id,
								selected: false,
								has_test: e.has_test,
								qty_questions: e.qty_questions,
							}
						}),
						tests:
							e.has_test !== 1 && e.participants.length
								? e.participants[0].tests.map((t) => {
										return { id: t.id, test_type: t.test_type, title: t.title }
								  })
								: null,
					}
				})

				this.qty_participants_base = this.event_dates[0].participants.length

				this.participants_profile.forEach((el) => {
					let obj = audience.data.find((obj) => {
						return obj.profile === el.id
					})
					if (obj) {
						el.qty_participants = obj.qty_participant
					}
				})

				this.block_results_momentarily = false

				if (this.status === 3 || this.status === 4) {
					if (this.event_dates && this.event_dates.length) {
						this.blockResultsMomentarily()
					}
				}

				this.$q.loading.hide()
			} catch (e) {
				console.log(e)
				this.$q.loading.hide()
			}
		},

		showAddParticipants() {
			this.participants_selected = []
			this.requestParticipants({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
			this.filter_participants = ''
			this.show_participants = true
		},

		async requestParticipants({ pagination }) {
			this.loading = true
			this.participants_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.participants_pagination.rowsPerPage,
				page: this.participants_pagination.page,
				search: this.filter_participants,
				ordering: order_by,
				presential_event_date_id: this.event_dates[this.tab_results]
					.presential_event_date_id,
			}

			try {
				const response = await this.$axios.get(
					`/presential/presential_events/${
						this.presential_event_id
					}/guests/get_users_not_invited/?${this.$qs.stringify(data)}`,
					this.getHeader
				)

				this.participants_pagination.rowsNumber = response.data.count

				this.participants_list = response.data.results.map((e) => {
					return {
						...e,
						branches: e.branches,
						selected: false,
						user_id: e.id,
						profile: e.profile_name,
						score: null,
						is_present: true,
					}
				})
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},

		addParticipants() {
			this.participants_selected.map((e) => {
				let participant = e
				participant.qty_questions = this.event_dates[this.tab_results].qty_questions
				participant.has_test = this.event_dates[this.tab_results].has_test
				participant.percent = 0
				participant.score = null

				this.event_dates.forEach((event) => {
					if (event.has_test === 3 && event.tests) {
						let partTests = event.tests ? event.tests.map((par) => par) : []
						return (participant.tests = partTests.map((test) => {
							return {
								...test,
								user_result: {
									user_score: null,
									user_percent: null,
									user_result_status: null,
									result_date: null,
								},
							}
						}))
					} else {
						participant.tests = []
					}
				})
				this.event_dates.forEach((event) => {
					event.participants.push(participant)
				})
			})

			this.clearParticipantsSelection()
			this.has_uninvited_guest = true
			this.show_participants = false
			this.saveResults()
		},

		async removeParticipants() {
			let participantsToRemove = this.participants_selected.filter((p) => !p.is_invited)

			let data = {
				users: participantsToRemove.map((e) => e.user_id),
				event_dates: this.event_dates.map((e) => e.presential_event_date_id),
			}

			try {
				const response = await this.$axios.post(
					`/presential/presential_events/${
						this.presential_event_id
					}/results/delete_users_result/`,
					data,
					this.getHeader
				)
				if (response) {
					participantsToRemove.map((e) => {
						let participants = this.event_dates[this.tab_results].participants.filter(
							(f) => f.user_id !== e.user_id
						)
						this.event_dates.forEach((event) => {
							event.participants = participants
						})
					})
				}
				this.qty_participants_base =
					this.qty_participants_base - participantsToRemove.length
			} catch (e) {
				console.log(e)
			} finally {
				this.clearParticipantsSelection()
			}
		},

		createdNewParticipants() {
			this.show_modal_create_users = true
		},

		closeRegisterUser(value) {
			console.log(value)
			this.show_modal_create_users = false
			if (value) {
				this.presential_event_id = this.$route.params.id
				this.createParticipantsProfile()
				this.requestEventDatesAndAudience()
				this.chevroletDocumentFix()
			}
		},

		async removeParticipant(props) {
			let data = {
				users: [props.row.user_id],
				event_dates: this.event_dates.map((e) => e.presential_event_date_id),
			}

			try {
				const response = await this.$axios.post(
					`/presential/presential_events/${
						this.presential_event_id
					}/results/delete_users_result/`,
					data,
					this.getHeader
				)
				if (response) {
					this.event_dates.forEach((event) => {
						event.participants.splice(props.row.__index, 1)
					})
					this.qty_participants_base = this.qty_participants_base - 1
				}
			} catch (e) {
				console.log(e)
			}
		},

		async saveResults() {
			this.$q.loading.show()

			let results = {
				event_dates: this.event_dates.map((e) => {
					return {
						...e,
						participants: e.participants,
					}
				}),
			}

			let audience = {
				profiles: this.participants_profile.map((p) => {
					return {
						id: p.id,
						qty_participants:
							p.qty_participants === '' || p.qty_participants === null
								? 0
								: p.qty_participants,
					}
				}),
			}

			try {
				const savedResults = await this.$axios.post(
					`/presential/presential_events/${this.presential_event_id}/results/`,
					results,
					this.getHeader
				)
				const savedAudience = await this.$axios.post(
					`/presential/presential_events/${
						this.presential_event_id
					}/results/set_participant_real/`,
					audience,
					this.getHeader
				)

				const response = await Promise.all([savedResults, savedAudience])

				if (response) {
					this.$q.notify({
						message: this.$t('results_save_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})
				}
			} catch (e) {
				console.log(e)

				if (e && e.response && e.response.data) {
					if (e.response.data.message.includes('Há mais usuários')) {
						this.$q.notify({
							message: this.$t('there_are_more_users_than_allowed_for_this_event'),
							type: 'negative',
							icon: 'fal fa-ban',
						})
					}
				} else {
					this.$q.notify({
						message: this.$t('results_save_error'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				}
			} finally {
				this.$q.loading.hide()
				this.show_participants = false
				this.requestEventDatesAndAudience()
			}
		},

		finishAppointment() {
			let event_finish = []
			let event_results = this.event_dates.find((e) => {
				if (!e.allow_to_finish) event_finish.push(e.allow_to_finish)
			})

			if (!event_finish.length) {
				this.show_finish = true
			} else {
				this.$q.notify({
					message: this.$t('you_must_fill_all_results'),
					type: 'negative',
					icon: 'fal fa-ban',
				})
			}
		},

		hideFinish() {
			this.$v.$reset()
			this.show_finish = false
		},

		async saveFinish() {
			this.$q.loading.show()
			this.show_finish = false

			try {
				let data = {
					event_dates: this.event_dates.map((e) => {
						return {
							...e,
							participants: e.participants,
						}
					}),
					finish_observation: this.finish_observation,
				}

				const response = await this.$axios.post(
					`/presential/presential_events/${this.presential_event_id}/finish_event/`,
					data,
					this.getHeader
				)

				if (response) {
					this.$q.notify({
						message: this.$t('appointment_finished_successfully'),
						type: 'positive',
						icon: 'fal fa-save',
					})
					this.$router.push({ name: 'appointments' })
				}
			} catch (e) {
				console.log(e)
				this.$q.notify({
					message: this.$t('finishing_appointment_error'),
					type: 'negative',
					icon: 'fal fa-ban',
				})
			} finally {
				this.$q.loading.hide()
			}
		},

		clearParticipantsSelection() {
			this.participants_selected = []
			this.requestParticipants({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		showCreateUsers() {
			this.show_create_users = true
		},

		addNewUser() {
			this.$v.new_user.$touch()

			if (!this.$v.new_user.$error) {
				let user = {
					document: this.new_user.document,
					profile: this.new_user.profile,
					full_name: this.new_user.full_name,
				}

				if (!this.register_fields.email_fields && this.new_user.email === '') {
					let url = process.env.SITE_URL.replace(
						/^(?:https?:\/\/)?(?:www\.)?/i,
						''
					).split('/')[0]

					user.email = `${this.new_user.document}@${url}`
				} else {
					user.email = this.new_user.email
				}

				this.new_users.push(user)

				this.new_user = {
					email: '',
					email_error: false,
					document: '',
					document_error: false,
					profile: '',
					full_name: '',
					percent: null,
				}

				this.$v.$reset()
			}
		},

		removeNewUser(index) {
			this.new_users.splice(index, 1)
		},

		async saveNewUsers() {
			this.$q.loading.show()

			if (!this.register_fields.email_fields && this.register_store.default_password) {
				this.new_users = this.new_users.map((e) => {
					return { ...e, password_to_change: this.register_store.default_password }
				})
			}

			let data = {
				new_users: this.new_users,
			}

			try {
				const response = await this.$axios.post(
					`/presential/presential_events/save_new_users_presential/`,
					data,
					this.getHeader
				)

				response.data.map((e) => {
					let participant = e
					participant.qty_questions = this.event_dates[this.tab_results].qty_questions
					participant.has_test = this.event_dates[this.tab_results].has_test
					participant.is_present = true

					this.event_dates.forEach((event) => {
						event.participants.push(participant)
					})
				})

				this.saveResults()
				this.hideCreateUsers()
			} catch (e) {
				console.log(e)

				this.$q.notify({
					message: this.$t('new_users_save_error'),
					type: 'negative',
					icon: 'fal fa-ban',
				})

				this.$q.loading.hide()
			}
		},

		hideCreateUsers() {
			this.show_create_users = false
			this.new_user = {
				email: '',
				email_error: false,
				document: '',
				document_error: false,
				profile: '',
				full_name: '',
			}
			this.new_users = []
		},

		getQuantityBranches(branches) {
			return branches.length > 0 ? branches.length : '0'
		},

		getTestLabel(test) {
			if (test === 1) return this.$t('event_without_tests')
			if (test === 2) return this.$t('event_with_presential_test')
			else return this.$t('event_with_online_test')
		},

		printAttendanceList() {
			let event = this.event_dates[this.tab_results]
			if (event) {
				let html = `<html>
                        <head></head>
                        <style>
                            table {
                                width:100%;
                            }
                            table, th, td {
                                border: 1px solid black;
                                border-collapse: collapse;
                            }
                        </style>
                        <body>
                            <h2>${this.$t('participants')} - ${this.fDate(event.hr_start)}</h2>
                            <table>`

				html += `<tr>
                        <th>${this.$t('name')}</th>
                        <th>${this.$t('email')}</th>
                        <th>${this.$t('document')}</th>
                        <th>${this.$t('signature')}</th>
                    </tr>`

				event.participants.map(
					(p) =>
						(html += `<tr>
                            <td>${p.full_name}</td>
                            <td>${p.email ? p.email : ''}</td>
                            <td>${p.document ? p.document : ''}</td>
                            <td></td>
                        </tr>`)
				)

				html += `</table></body></html>`

				let win = window.open()
				win.document.open().write(html)
				win.print()
			} else return
		},

		printEventResults() {
			let event = this.event_dates[this.tab_results]

			if (event) {
				let html = `<html>
                        <head></head>
                        <style>
                            body {
                                margin: 10px;
                            }
                            table {
                                width:100%;
                            }
                            table, th, td {
                                padding: 2px;
                                border: 1px solid black;
                                border-collapse: collapse;
                            }
                        </style>
                        <body>
                            <h2>${this.events_title}</h2>
                            <h2>${event.company_branch_name ? event.company_branch_name : ''}</h2>
                            <h3>${event.partner_name ? this.$t('partner_branch') + ':' : ''}
                                ${event.partner_name ? event.partner_name : ''}</h3>
                            <h3>${this.$t('participants')} - ${this.fDate(event.hr_start)}</h3>
                            <table>`

				if (event.has_test === 3) {
					html += `<tr>
                        <th>${this.$t('name')}</th>
                        <th>${this.$t('email')}</th>
                        <th>${this.$t('document')}</th>
                        <th>${this.$t('branch')}</th>
                        <th>${this.$t('present')}</th>
                        <th>${this.$t('score')}</th>
                        <th>${this.$t('percent')}</th>
                        <th>${this.$t('result')}</th>
                    </tr>`

					event.participants.map(
						(p) =>
							(html += `<tr>
                                <td>${p.full_name}</td>
                                <td>${p.email ? p.email : ''}</td>
                                <td>${p.document ? p.document : ''}</td>
                                <td>${p.branches.length ? p.branches[0] : ''}</td>
                                <td>${p.is_present ? this.$t('yes') : this.$t('no')}</td>
                                <td>
                                    ${
										p.tests.length
											? p.tests[this.tab_tests].user_result.user_score
												? p.tests[this.tab_tests].user_result.user_score
												: ''
											: ''
									}
                                </td>
                                <td>
                                    ${
										p.tests.length
											? p.tests[this.tab_tests].user_result.user_percent
												? p.tests[this.tab_tests].user_result.user_percent
												: ''
											: ''
									}
                                </td>
                                <td>
                                    ${
										p.tests.length
											? p.tests[this.tab_tests].user_result
													.user_result_status === 1
												? this.$t('approved')
												: this.$t('reproved')
											: ''
									}
                                </td>
                            </tr>`)
					)
				} else {
					html += `<tr>
                        <th>${this.$t('name')}</th>
                        <th>${this.$t('email')}</th>
                        <th>${this.$t('document')}</th>
                        <th>${this.$t('branch')}</th>
                        <th>${this.$t('present')}</th>
                    </tr>`

					event.participants.map(
						(p) =>
							(html += `<tr>
                                <td>${p.full_name}</td>
                                <td>${p.email ? p.email : ''}</td>
                                <td>${p.document ? p.document : ''}</td>
                                <td>${p.branches.length ? p.branches[0] : ''}</td>
                                <td>${p.is_present ? this.$t('yes') : this.$t('no')}</td>
                            </tr>`)
					)
				}

				html += `</table></body></html>`

				let win = window.open()
				win.document.open().write(html)
				win.print()
			} else return
		},

		async emailUnique() {
			if (this.new_user.email) {
				let fd = new FormData()
				fd.append('email', this.new_user.email)

				try {
					const response = await this.$axios.post(
						`/register_user/check_user_email_existance/`,
						fd,
						this.getHeader
					)
					if (response.data.exists) {
						this.new_user.email_error = true
					} else this.new_user.email_error = false
				} catch (e) {
					console.log(e)
				}
			} else this.new_user.email_error = false
		},

		async documentUnique() {
			if (this.new_user.document) {
				let fd = new FormData()
				fd.append('document', this.new_user.document)

				try {
					const response = await this.$axios.post(
						`/register_user/check_user_document_existance/`,
						fd,
						this.getHeader
					)
					if (response.data.exists) {
						this.new_user.document_error = true
					} else this.new_user.document_error = false
				} catch (e) {
					console.log(e)
				}
			} else this.new_user.document_error = false
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm'
						break
					default:
						format = 'MM-DD-YYYY HH:mm'
						break
				}

				return date.formatDate(d, format)
			}
		},

		fDateOnly(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY'
						break
					default:
						format = 'MM-DD-YYYY'
						break
				}

				return date.formatDate(d, format)
			}
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getResult(participant) {
			if (this.event_dates[this.tab_results].has_test === 2) {
				if (this.event_dates[this.tab_results].minimum_score_approval !== '') {
					if (!participant.is_present) return 'absent'
					if (participant.is_present && participant.score === null) return ''
					if (
						participant.score !== '' &&
						participant.score >=
							this.event_dates[this.tab_results].minimum_score_approval
					) {
						return 'approved'
					} else return 'reproved'
				}
			} else {
				if (participant.status === 1) return 'approved'
				if (participant.status === 2) return 'reproved'
				if (participant.status === 3) return 'absent'
				else return ''
			}
		},

		getResultOnlineTest(status) {
			if (status === 1) return this.$t('approved')
			if (status === 2) return this.$t('reproved')
			else return ''
		},

		showImportResult() {
			this.show_result_import = true
		},

		resultImportUpload(url) {
			this.file = url
		},

		async importResult() {
			if (this.file) {
				let data = {
					file_url: this.file,
					import_type: 'results',
				}

				try {
					const response = await this.$axios.post(
						`/presential/presential_events/${
							this.presential_event_id
						}/import/import_invited_users_and_results/`,
						data,
						this.getHeader
					)

					if (response) {
						this.$q.notify({
							message: this.$t('guests_save_success'),
							type: 'positive',
							icon: 'fal fa-save',
						})
					}
				} catch (e) {
					console.log(e)

					if (e && e.response && e.response.data) {
						if (e.response.data.message.includes('Há mais usuários')) {
							this.$q.notify({
								message: this.$t(
									'there_are_more_users_than_allowed_for_this_event'
								),
								type: 'negative',
								icon: 'fal fa-ban',
							})
						}
					} else {
						this.$q.notify({
							message: this.$t('guests_save_error'),
							type: 'negative',
							icon: 'fal fa-ban',
						})
					}
				} finally {
					this.requestEventDatesAndAudience()
					this.$q.loading.hide()
					this.show_result_import = false
				}
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		async getTemplate() {
			this.$q.loading.show({
				message: 'Aguarde, gerando planilha',
			})
			try {
				const response = await this.$axios.get(
					`/presential/presential_events/${
						this.presential_event_id
					}/import/download_xlsx/`,
					this.getHeader
				)
				this.forceFileDownload(response.data.path_url)
			} catch (e) {
				console.log(e)
			} finally {
				this.$q.loading.hide()
			}
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		createParticipantsProfile() {
			this.participants_profile = this.client_profiles.map((p) => {
				return {
					...p,
					label: p.label.toLowerCase(),
					id: p.value,
					qty_participants: '',
				}
			})
		},

		showEventTab(event) {
			let date1 = moment(event.hr_end)
			let date2 = moment(new Date())

			let diff = moment.duration(date1.diff(date2)).asMinutes()
			if (diff > 0) return false
			else return true
		},

		showEventNotFinishedWarning(event) {
			if (event.presential_event_date_type == 1) {
				return false
			} else if (event.presential_event_date_type == 2) {
				if (event.status == 8) return false
				else return true
			} else {
				if (event.status == 7) return false
				else return true
			}
		},

		goToEvent(event) {
			this.$emit('goToUnfinishedEvent', event.presential_event_date_id)
		},

		chevroletDocumentFix() {
			if (
				process.env.PROJECT_FOLDER === 'universidadechevrolet' &&
				this.id_user_client_country_selected === 32 &&
				this.id_user_language_selected == 1
			) {
				this.columns_participants = this.columns_participants.map((e) =>
					e.field == 'document' ? { ...e, label: 'cpf' } : e
				)
				this.columns_participants_tests = this.columns_participants_tests.map((e) =>
					e.field == 'document' ? { ...e, label: 'cpf' } : e
				)
				this.participants_columns = this.participants_columns.map((e) =>
					e.field == 'document' ? { ...e, label: 'cpf' } : e
				)
			} else {
				this.columns_participants = this.columns_participants.map((e) =>
					e.field == 'document' ? { ...e, label: 'document' } : e
				)
				this.columns_participants_tests = this.columns_participants_tests.map((e) =>
					e.field == 'document' ? { ...e, label: 'document' } : e
				)
				this.participants_columns = this.participants_columns.map((e) =>
					e.field == 'document' ? { ...e, label: 'document' } : e
				)
			}
		},

		blockResultsMomentarily() {
			let firstEvent = this.event_dates[0]
			if (firstEvent) {
				let date1 = moment(firstEvent.hr_end)
				let date2 = moment(new Date())

				let diff = moment.duration(date1.diff(date2)).asMinutes()

				if (diff > 0) this.block_results_momentarily = true
				else this.block_results_momentarily = false
			} else this.blockResultsMomentarily = true
		},

		translateProfiles(value) {
			let profile = value.toUpperCase()
			let term = this.profiles.find((e) => e.translations[0].name.toUpperCase() === profile)
			if (term) {
				let translated = term.label.toLowerCase()
				return translated.charAt(0).toUpperCase() + translated.slice(1)
			} else return value
		},
		addSelectAll(participants) {
			if (this.event_dates[this.tab_results].is_seleted) {
				this.event_dates[this.tab_results].participants = participants.map((e) => ({
					...e,
					is_present: true,
				}))
			} else {
				this.event_dates[this.tab_results].participants = participants.map((e) => ({
					...e,
					is_present: false,
				}))
			}
			this.event_dates[this.tab_results].is_seleted = !this.event_dates[this.tab_results]
				.is_seleted
		},
	},

	created() {
		this.presential_event_id = this.$route.params.id
		this.createParticipantsProfile()

		this.requestEventDatesAndAudience()
		this.chevroletDocumentFix()
	},

	watch: {
		tab_results: function() {
			this.tab_tests = '0'
		},
		id_user_language_selected: function() {
			this.chevroletDocumentFix()
		},
	},

	validations() {
		return {
			event_dates: {
				$each: {
					participants: {
						minLength: minLength(1),
						$each: {
							score: {
								requiredIf: requiredIf((participant) => {
									participant.has_test === 1 ? false : true
								}),
							},
						},
					},
				},
			},
			new_user: {
				email: {
					email,
					requiredIf: requiredIf(() => {
						return (
							this.register_fields.email_fields &&
							this.register_fields.email_fields_mandatory
						)
					}),
					emailUnique() {
						if (!this.new_user.email_error) return true
						else return false
					},
				},
				document: {
					requiredIf: requiredIf(() => {
						return (
							this.register_fields.document && this.register_fields.document_mandatory
						)
					}),
					documentUnique() {
						if (!this.new_user.document_error) return true
						else return false
					},
				},
				profile: { required },
				full_name: { required },
			},
		}
	},
}
</script>

<style lang="stylus">
.event-card
    box-shadow 0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12)
    width: 100%

.custom-input
    text-transform capitalize
    input
        text-align right
</style>
